import React from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { I18n as I } from 'react-redux-i18n';
import { isFunc, unaccent } from 'vdlib';
import { Col, Row, Input, Select, Collapse } from 'antd';

import { FilterOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const { Option } = Select;
const filterStyle = { display: 'flex', marginBottom: 10 };

// const stringFilterOption =
const filterOption = (input, option) => {
  const inputText = unaccent(input).toLowerCase();
  const optionText = unaccent(option.children).toLowerCase();
  return optionText.indexOf(inputText) >= 0;
};

const PartiesListFilters = ({ filters, location, setFilter, partyTypes }) => {
  // returns a default filter if location filters correspond to location
  const extractFilter = React.useMemo(() => {
    const { Value: locationFilterValue } = filters
      ? filters.find(x => x.Name === 'forLocation') || {}
      : {};
    const defaultValueFormatter = value => value || null;
    return locationFilterValue === location.pathname
      ? (name, valueFormatter) => {
          const { Value: filterValue } = filters
            ? filters.find(f => f.Name === name) || {}
            : {};
          return isFunc(valueFormatter)
            ? valueFormatter(filterValue)
            : defaultValueFormatter(filterValue);
        }
      : () => null;
  }, [filters, location]);

  return (
    <Collapse defaultActiveKey={['1']}>
      <Panel
        header={
          <div>
            <FilterOutlined
              style={{
                marginTop: 2,
                fontSize: 18,
                position: 'absolute',
                color: '#364150',
              }}
            />
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: '#364150',
                marginLeft: 25,
              }}
            >
              Filters
            </div>
          </div>
        }
        key="1"
      >
        <Row>
          <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
            <span className="gt-estimate-cell-span">{I.t('PARTY_TYPE')}</span>
            <Select
              allowClear={true}
              showSearch
              style={{ width: 200 }}
              placeholder={`${I.t('DATAGRID_CHOOSE')} ${I.t('PARTY_TYPE')}`}
              filterOption={filterOption}
              onChange={value => setFilter('PartyTypeID', value)}
              defaultValue={extractFilter('PartyTypeID')}
            >
              {partyTypes.map(x => (
                <Option value={x.ID}>{x.Description}</Option>
              ))}
            </Select>
          </Col>
          <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
            <span className="gt-estimate-cell-span">{I.t('FIRSTNAME')}</span>
            <Input
              style={{
                width: 200,
              }}
              onChange={e => setFilter('FirstName', e.target.value)}
              defaultValue={extractFilter('FirstName')}
            />
          </Col>
          <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
            <span className="gt-estimate-cell-span">{I.t('SURNAME')}</span>
            <Input
              style={{
                width: 200,
              }}
              onChange={e => setFilter('SurName', e.target.value)}
              defaultValue={extractFilter('SurName')}
            />
          </Col>
          <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
            <span className="gt-estimate-cell-span">{I.t('EMAIL')}</span>
            <Input
              style={{
                width: 200,
              }}
              onChange={e => setFilter('Email', e.target.value)}
              defaultValue={extractFilter('Email')}
            />
          </Col>
        </Row>
      </Panel>
    </Collapse>
  );
};

const lookupPropType = arrayOf(
  shape({
    Code: string,
    Description: string,
    ID: number,
  })
);

PartiesListFilters.propTypes = {
  filters: arrayOf(shape({ Name: string, Value: string })),
  partyTypes: lookupPropType,
};

export default PartiesListFilters;
